import { FC } from 'react';

export const PolicyHead: FC = () => {
  return <title>Cookies Policy</title>;
};
